<template>
  <div>
    <h4 class="title">Video</h4>
    <div class="field">
      <label class="label"> फाइलको नाम</label>
      <div class="control">
        <input
          class="input"
          v-model="form.name"
          type="text"
          placeholder="फाइलको नाम"
          :class="{ 'is-danger': errors.name }"
        />
        <p class="help is-danger" v-if="errors.name">फाइलको नाम आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <label class="label">भिडियो</label>
      <div class="control">
        <input
          class="input"
          v-model="form.video"
          type="url"
          placeholder="भिडियो लिङ्क"
          :class="{ 'is-danger': errors.video }"
        />
        <p class="help is-danger" v-if="errors.video">भिडियो आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <label class="label">फोटो</label>
      <div class="control">
        <div class="file has-name">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              ref="file"
              @change="upload"
              accept=".jpg,.jpeg,.png"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label"> Choose a file </span>
            </span>
            <span class="file-name" style="min-width: 230px">
              {{ fileName }}
            </span>
          </label>
        </div>
        <p class="help is-danger" v-if="errors.image">फोटो आवश्यक छ।</p>
      </div>
    </div>
    <button
      class="button submit pbutton"
      :class="{ 'is-loading': loading }"
      @click="validate(saveVideo)"
      v-if="edit == false"
    >
      सेभ गर्नुहोस
    </button>
    <button
      class="button submit pbutton"
      :class="{ 'is-loading': loading }"
      @click="validate(updateVideo)"
      v-else
    >
      अपडेट गर्नुहोस्
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "../../main";
export default {
  data() {
    return {
      form: {
        name: "",
        video: "",
        image: null,
      },
      loading: false,
      fileName: "",
      edit: false,
      errors: {
        name: false,
        video: false,
        image: false,
      },
    };
  },
  created() {
    bus.$on("edit-video", (e) => {
      this.edit = true;
      this.form = e;
      this.fileName = this.form.image;
      this.resetErrors();
    });
  },
  methods: {
    resetErrors() {
      this.errors = {
        name: false,
        video: false,
        image: false,
      };
    },
    upload() {
      const file = this.$refs.file.files[0];

      // Check if the file type is valid
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (file && validTypes.includes(file.type)) {
        this.fileName = file.name;
        this.form.image = file;
        this.errors.image = false;
      } else {
        // If the file is invalid, reset the input and show an error
        this.fileName = "";
        this.form.image = null;
        this.errors.image = true;
        this.$notify.error({
          position: "bottom right",
          msg: "Only .png, .jpg, and .jpeg files are allowed!",
          timeout: 2000,
        });
        this.$refs.file.value = ""; // Reset the file input
      }
    },
    clearForm() {
      this.form = {
        name: "",
        video: "",
        image: null,
      };
      this.fileName = "";
      this.resetErrors();
    },
    validate(callback) {
      this.resetErrors();
      this.errors.name = !this.form.name;
      this.errors.video = !this.form.video;
      this.errors.image = !this.form.image;

      if (!this.errors.name && !this.errors.video && !this.errors.image) {
        callback();
      }
    },
    updateVideo() {
      this.loading = true;
      const fd = new FormData();
      fd.append("name", this.form.name);
      fd.append("video", this.form.video);
      if (this.form.image !== null) {
        fd.append("image", this.form.image);
      }
      axios
        .post("api/video/update/" + this.form.id, fd)
        .then((res) => {
          this.loading = false;
          this.$notify.success({
            position: "bottom right",
            msg: "Video updated successfully!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
          this.clearForm();
          bus.$emit("store", true);
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.error({
            position: "bottom right",
            msg: "Video could not be updated!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
        });
    },
    saveVideo() {
      this.loading = true;
      const fd = new FormData();
      fd.append("name", this.form.name);
      fd.append("video", this.form.video);
      if (this.form.image !== null) {
        fd.append("image", this.form.image);
      }
      axios
        .post("/api/store-calendar-videos", fd)
        .then((res) => {
          this.loading = false;
          this.$notify.success({
            position: "bottom right",
            msg: "Video added successfully!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
          this.clearForm();
          bus.$emit("store", true);
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.error({
            position: "bottom right",
            msg: "Video could not be stored!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.label {
  color: #6a6a6a;
  font-weight: 400;
}
.title {
  font-size: 1.5rem;
  margin-bottom: 0px;
  color: #254594;
  margin-bottom: 10px;
}
.pbutton {
  background: #254594;
  color: #fff;
  border-radius: 34px;
  width: 153px;
  height: 40px;
  margin-top: 30px;
}
.pbutton:hover {
  color: #fff;
}
.pbutton:focus {
  color: #fff;
}
.is-danger {
  border-color: #f14668;
}
</style>
